import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import { 
  getReminderAnalyses, 
  getReminderAnalysis,
  clearLocalReminderAnalyses,
  clearLocalActiveReminderAnalysis
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  reminderAnalysis: { 
    id: '', 
    result: '', 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false,  
    reminderAnalysis: false
  }
};

const slice = createSlice({
  name: 'reminderAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getReminderAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getReminderAnalyses.fulfilled, (state, action) => {
        const { reminder_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...reminder_analyses], 'id');

        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getReminderAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getReminderAnalysis.pending, (state) => {
        state.loading.reminderAnalysis = true;
      })
      .addCase(getReminderAnalysis.fulfilled, (state, action) => {
        const { data: { reminder_analysis }, cable } = action.payload;
        const foundedReminderAnalysis = !!_find(state.all.data, (s) => s.id === reminder_analysis.id);
        const updatedReminderAnalysis = { ...state.reminderAnalysis, ...reminder_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedReminderAnalysis ? _map(state.all.data, (e) => e.id === reminder_analysis.id ? { ...e, ...reminder_analysis } : e) : [...[reminder_analysis], ...oldAllData]; 
        const pagination = foundedReminderAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.reminderAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedReminderAnalysis && !cable) state.reminderAnalysis = updatedReminderAnalysis;       
      })
      .addCase(getReminderAnalysis.rejected, (state) => {
        state.loading.reminderAnalysis = false;
      })
      .addCase(clearLocalReminderAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveReminderAnalysis, state => {
        state.reminderAnalysis = initialState.reminderAnalysis;
      })
  }
})

export default slice.reducer;